var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['trade-status', _setup.tradeClass]},[(_setup.isTradeRejectedOrCanceled && _vm.showIcon !== false)?_c('IconAlertCircle',{staticClass:"alert-icon mr-1"}):_vm._e(),_vm._v(" "+_vm._s(_setup.status)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }